export const predefinedColors = [
    '#342312',
    '#d0021b',
    '#f5a623',
    '#f8e702',
    '#8b572a',
    '#7ed303',
    '#417505',
    '#bd10e0',
    '#9013fe',
    '#4a90e2',
    '#50e3c2',
    '#b81786',
    '#000000',
    '#4a4a4a',
    '#9b9b9b',
    '#ffffff',
];
